const ModuleService = function () {
  this.completePages = function (model) {
    const lastPage = model.activities.last().pages.last();
    model.setLastCompletedPage(lastPage);
    model.applyModuleStatus();
    model.set('completed', true);
  };

  this.markComplete = function (model) {
    model.progress.markComplete();
  };
};

export default new ModuleService();
